export const MANAGER_UPDATES_EDITABLE_ROLES = ['Super Admin', 'Admin', 'Investment Lead', 'Investment Member'];

export const allStrategiesTableColumns = [
  { title: 'Strategy', key: 'STRATEGY', width: 18, keySort: 'strategy' },
  { title: 'Manager', key: 'MANAGER', width: 18, keySort: 'manager' },
  { title: 'Status', key: 'STATUS', width: 16, keySort: 'status' },
  { title: '# of updates', key: 'NUM_OF_UPDATES', width: 16, keySort: '# of updates' },
  { title: 'New AI Suggestions', key: 'NEW_AI_SUGGESTIONS', width: 16, keySort: 'new AI suggestions' },
  { title: 'Last Published Update', key: 'LAST_PUBLISHED_UPDATE', width: 16, keySort: 'last published update' }
];

export const allStrategiesTableMobileSort = [
  {
    title: 'Investment • A -> Z',
    key: 'STRATEGY',
    asc: true
  },
  {
    title: 'Investment • Z -> A',
    key: 'STRATEGY',
    asc: false
  },
  {
    title: 'Manager • A -> Z',
    key: 'MANAGER',
    asc: true
  },
  {
    title: 'Manager • Z -> A',
    key: 'MANAGER',
    asc: false
  },
  {
    title: 'Status • A -> Z',
    key: 'STATUS',
    asc: false
  },
  {
    title: 'Status • Z -> A',
    key: 'STATUS',
    asc: true
  },
  {
    title: '# of updates • Max -> Min',
    key: 'NUM_OF_UPDATES',
    asc: false
  },
  {
    title: '# of updates • Min -> Max',
    key: 'NUM_OF_UPDATES',
    asc: true
  },
  {
    title: 'New AI Suggestions • Newest -> Oldest',
    key: 'NEW_AI_SUGGESTIONS',
    asc: false
  },
  {
    title: 'New AI Suggestions • Oldest -> Newest',
    key: 'NEW_AI_SUGGESTIONS',
    asc: true
  },
  {
    title: 'Last Published Update • Newest -> Oldest',
    key: 'LAST_PUBLISHED_UPDATE',
    asc: false
  },
  {
    title: 'Last Published Update • Oldest -> Newest',
    key: 'LAST_PUBLISHED_UPDATE',
    asc: true
  }
];

export const updatesTableColumnsEditMode = [
  { title: 'Update', key: 'NAME', width: 20, keySort: 'update name' },
  { title: 'Owner', key: 'OWNER', width: 19, keySort: 'owner' },
  { title: 'Date', key: 'STATUS_UPDATED_DATE', width: 19, keySort: 'date' },
  { title: 'Status', key: 'STATUS', width: 19, keySort: 'status' },
  { title: 'Flag', key: 'FLAG_LABEL', width: 19, keySort: 'flag' },
  { title: '', key: '', width: 4, keySort: '' }
];

export const allManagerUpdatesTableMobileSort = [
  {
    title: 'Update • A -> Z',
    key: 'NAME',
    asc: true
  },
  {
    title: 'Update • Z -> A',
    key: 'NAME',
    asc: false
  },
  {
    title: 'Owner • A -> Z',
    key: 'OWNER',
    asc: true
  },
  {
    title: 'Owner • Z -> A',
    key: 'OWNER',
    asc: false
  },
  {
    title: 'Date • A -> Z',
    key: 'STATUS_UPDATED_DATE',
    asc: false
  },
  {
    title: 'Date • Z -> A',
    key: 'STATUS_UPDATED_DATE',
    asc: true
  },
  {
    title: 'Flag • Max -> Min',
    key: 'FLAG_LABEL',
    asc: false
  },
  {
    title: 'Flag • Min -> Max',
    key: 'FLAG_LABEL',
    asc: true
  }
];
